<template lang="pug">
    .settings(v-if='settings')
        div(v-for="({ theme, num }, index) in settings.examples")
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
                | {{ num }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_themeForExample', {example: null}) }}:
                | {{ getThemeName(theme.name) }}
            br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { camelCase } from 'lodash';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        },
        methods: {
            getThemeName(name) {
                return this.$i18n.t('trainer.trainer_gameFormSetting_' + camelCase(name));
            },
        },
    }
</script>



